import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { mqMin } from 'utils/responsive';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';
import ImgPerson01 from 'ui/images/article/thinking_men.png';
import ImgMatch from 'ui/images/article/match.png';
import { ValuationEstimateForm } from 'ui/components/public/patterns/ValuationEstimateForm/ValuationEstimateForm';

const PageContainer = styled.div`
    width: 100%;
    padding: 60px 20px;
    background-color: var(--cream);

    img {
        width: 100%;
        height: auto;
    }

    ${mqMin('SP')} {
        padding: 90px 20px;
    }

    ${mqMin('NARROW')} {
        padding: 120px 20px;
    }
`;

const DecorativeWrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    min-height: 400px;

    ${mqMin('NARROW')} {
        min-height: 557px;
    }
`;

const TabShape = styled.div`
    width: 11rem;
    height: 2.3rem;
    background: #fff;
    border: 2px solid #ee793f;
    border-bottom: none;
    border-radius: 20px 20px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    z-index: 2;
    position: relative;
    margin-bottom: -2.5px;

    ${mqMin('SP')} {
        width: 20rem;
        height: 3.9rem;
    }

    ${mqMin('NARROW')} {
        width: 18rem;
        height: 3.6rem;
    }
`;

const TabTitle = styled.h2`
    color: #ee793f;
    text-align: center;
    font-size: 1rem;
    font-weight: 700;
    line-height: 160%;
    letter-spacing: 1.2px;
    margin: 0;

    ${mqMin('SP')} {
        font-size: 1.8rem;
    }

    ${mqMin('NARROW')} {
        font-size: 1.7rem;
    }
`;

const MainBox = styled.div`
    position: relative;
    width: 100%;
    min-height: 350px;
    background: #fff;
    border: 2px solid #ee793f;
    border-radius: 20px;
    padding: 30px 20px 60px 20px;
    z-index: 1;

    ${mqMin('SP')} {
        padding: 30px 20px 40px 20px;
    }

    ${mqMin('NARROW')} {
        min-height: 503px;
        padding: 30px 40px 60px 40px;
    }
`;

const LeftIllustration = styled.div`
    width: 4rem;
    margin-bottom: -0.8rem;
    height: auto;
    z-index: 3;
    position: absolute;
    margin-right: 13.5rem;
    z-index: 3;

    ${mqMin('SP')} {
        width: 9.6rem;
        margin-bottom: -2.2rem;
        margin-right: 29rem;
    }

    ${mqMin('NARROW')} {
        width: 8rem;
        margin-right: 27rem;
        margin-bottom: -1.7rem;
    }
`;

const RightIllustration = styled.div`
    width: 5rem;
    margin-bottom: -0.2rem;
    height: auto;
    z-index: 3;
    position: absolute;
    margin-left: 16rem;

    ${mqMin('SP')} {
        width: 14rem;
        margin-bottom: -0.5rem;
        margin-left: 34.5rem;
    }

    ${mqMin('NARROW')} {
        width: 10rem;
        margin-bottom: -0.4rem;
        margin-left: 29rem;
    }
`;

const TopContent = styled.div`
    display: flex;
    align-items: end;
    justify-content: center;
    position: relative;
`;

export const ValuationEstimate = () => {
    useEffect(() => {
        // topページにのみ適用するcssを追加
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/top.css';
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <>
            <TopHeader />
            <PageContainer>
                <TopContent>
                    <LeftIllustration>
                        <img src={ImgPerson01} alt="イラスト" />
                    </LeftIllustration>
                    <RightIllustration>
                        <img src={ImgMatch} alt="イラスト" />
                    </RightIllustration>
                    <TabShape>
                        <TabTitle>簡易企業価値算定</TabTitle>
                    </TabShape>
                </TopContent>
                <DecorativeWrapper>
                    <MainBox>
                        <ValuationEstimateForm />
                    </MainBox>
                </DecorativeWrapper>
            </PageContainer>
            <TopFooter />
        </>
    );
};
